import loginModule from '../loginModule.js';

function loginBase() {
  return {
    restrict: 'A',
    replace: false,
    templateUrl: 'login-base',
    controller: 'loginController',
    link: function link(scope, element, attrs) {
      scope.loginBaseParams = {
        isFacebookSignInEnabled: attrs.isFacebookSignInEnabled === 'true',
        returnUrl: attrs.returnUrl
      };
    }
  };
}

loginModule.directive('loginBase', loginBase);

export default loginBase;
